interface CardProps {
  children: React.ReactNode;
  variant?: 'glass' | 'gradient' | 'solid';
  className?: string;
}

export default function Card({ children, variant = 'glass', className = '' }: CardProps) {
  const baseClasses = 'rounded-2xl p-6 transition-all duration-300';
  
  const variants = {
    glass: 'glass-effect hover:bg-white/10 hover:border-amber-300/40',
    gradient: 'glass-gradient hover:from-amber-400/15 hover:to-yellow-500/10',
    solid: 'bg-slate-800 border border-amber-200/20 hover:border-amber-300/40'
  };
  
  const classes = `${baseClasses} ${variants[variant]} ${className}`;
  
  return (
    <div className={classes}>
      {children}
    </div>
  );
}
